import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {
  Link,
  LinkIcon,
} from '../../components'
import Styles from './NotFound.css'

@CSSModules(Styles)
export default class NotFound extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Not found 404',
      description: 'Sorry, nothing here.',
      url: config.domain + config.routes.notFound
    }
  }

  render() {
    return (
      <div styleName='page'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <div styleName='main'>
          <div styleName='notfound'>
            <h1>Sorry, nothing here.</h1>
            <p>
              <Link
                to={config.routes.home}
                title='Home'
              >
                Click here to return to the home page<LinkIcon />
              </Link>
            </p>
          </div>
        </div>

        { /* <GetStartedInput /> */ }

      </div>
    )
  }
}
